/**
 * Success toasts once a session mail is sent. The store sends one event per attendee, so the plural is
 * the only on-screen count of who was mailed. One helper per action: « Notifier » must not read as a convocation.
 */
export function convocationSuccessMessage(eventCount: number): string {
  return eventCount > 1 ? "Les convocations ont bien été envoyées" : "La convocation a bien été envoyée";
}

export function notificationSuccessMessage(eventCount: number): string {
  return eventCount > 1 ? "Les notifications ont bien été envoyées" : "La notification a bien été envoyée";
}
